import {useLocation, useRoutes} from 'react-router-dom';
import MainLayout from "../layout/MainLayout";
import FirstScreenPage from "../pages/FirstScreenPage";
import LoginPage from "../pages/LoginPage";
import LoginOtherPage from "../pages/LoginOtherPage";
import FreeInternetRightsPage from "../pages/FreeInternetRightsPage";
import InternetPackagesPage from "../pages/InternetPackagesPage";
import ForgotPasscodePage from "../pages/ForgotPasscodePage";
import MilesAndSmilesRegisterPage from "../pages/MilesAndSmilesRegisterPage";
import LoginOfferPage from "../pages/LoginOfferPage";
import RemainingUsagePage from "../pages/RemainingUsagePage";
import PurchasePackagePage from "../pages/PurchasePackagePage";
import PaymentPage from "../pages/PaymentPage";
import FeedbackPage from "../pages/FeedbackPage";
import FrequentlyAskedQuestionsPage from "../pages/FrequentlyAskedQuestionsPage";
import DiagnosticPage from "../pages/DiagnosticPage";
import React from "react";
import {useTranslation} from "react-i18next";
import {useRecoilState, useSetRecoilState} from "recoil";
import {loadingAtom} from "../store/LoadingStore";
import {userAtom} from "../store/UserStore";
import {dialogAtom} from "../store/DialogStore";
import {flightAtom} from "../store/FlightStore";
import {informationAtom} from '../store/InformationStore';
import SystemLoginPage from '../pages/SystemLoginPage';
import SimulationPage from '../pages/SimulationPage';
import PromotionCodePage from '../pages/PromotionCodePage';
import {useSafeNavigate} from '../util/useSafeNavigate';
import AdminPage from '../pages/AdminPage';

export default function ThemeRoutes(prop) {
    const {t, i18n} = useTranslation();
    const safeNavigate = useSafeNavigate();
    const location = useLocation();
    const [user, setUser] = useRecoilState(userAtom);
    const [flight, setFlight] = useRecoilState(flightAtom);
    const setLoading = useSetRecoilState(loadingAtom);
    const setDialogDynamic = useSetRecoilState(dialogAtom);
    const log = prop.log;
    const initListener = prop.initListener;
    const setInformation = useSetRecoilState(informationAtom);

    const handleInformation = (result) => {
        setInformation(prev => ({
            ...prev,
            type: result
        }));
    }

    const props = {
        t: t,
        i18n: i18n,
        navigate: safeNavigate,
        location: location,
        user: user,
        setUser: setUser,
        flight: flight,
        setFlight: setFlight,
        setLoading: setLoading,
        setDialogDynamic: setDialogDynamic,
        log: log,
        handleInformation: handleInformation
    }

    return useRoutes([{
        path: '/',
        element: <MainLayout/>,
        children: [
            {path: '/system-login', element: <SystemLoginPage props={props}/>},
            {path: '/', element: <FirstScreenPage initListener={initListener} props={props}/>},
            {path: '/login', element: <LoginPage props={props}/>},
            {path: '/login-other', element: <LoginOtherPage props={props}/>},
            {path: '/free-internet-rights', element: <FreeInternetRightsPage props={props}/>},
            {path: '/internet-packages', element: <InternetPackagesPage props={props}/>},
            {path: '/forgot-password', element: <ForgotPasscodePage props={props}/>},
            {path: '/miles-and-smiles-register', element: <MilesAndSmilesRegisterPage props={props}/>},
            {path: '/login-offer', element: <LoginOfferPage props={props}/>},
            {path: '/remaining-usage', element: <RemainingUsagePage props={props}/>},
            {path: '/purchase-package', element: <PurchasePackagePage props={props}/>},
            {path: '/payment', element: <PaymentPage props={props}/>},
            {path: '/feedback', element: <FeedbackPage props={props}/>},
            {path: '/system-status', element: <FirstScreenPage props={props}/>},
            {path: '/promotion-code', element: <PromotionCodePage props={props}/>},
            {path: '/frequently-asked-questions', element: <FrequentlyAskedQuestionsPage props={props}/>},
            {path: '/diag', element: <DiagnosticPage props={props}/>},
            {path: '/DIAG', element: <DiagnosticPage props={props}/>},
            {path: '/simulation', element: <SimulationPage initListener={initListener} props={props}/>},
            {path: '/admin', element: <AdminPage/>}
        ]
    }]);
}
